
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ProductU91JuycuoUMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Product.vue?macro=true";
import { default as CategorynBTkRHgiSlMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Category.vue?macro=true";
import { default as ShippingbFxDrNUDAsMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Shipping.vue?macro=true";
import { default as SwitchView6k3cffjYizMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/SwitchView.vue?macro=true";
import { default as Billing3vERk0PxZpMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Billing.vue?macro=true";
import { default as PaymentPfdlfbqluKMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Payment.vue?macro=true";
import { default as ThankYouiwrivwlizEMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/ThankYou.vue?macro=true";
import { default as CheckoutjX0jgTuAzjMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout.vue?macro=true";
import { default as MyAccount7D5P6zlkwSMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount.vue?macro=true";
import { default as _91id_93KkZXB3l9zlMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/[id].vue?macro=true";
import { default as CartUzBGCvrB5aMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Cart.vue?macro=true";
import { default as FilialfinderWQu5JrchmOMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Filialfinder.vue?macro=true";
import { default as GuestCreateReturnNPXRbIKfojMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/GuestCreateReturn.vue?macro=true";
import { default as GuestOrderDetailsKsqxWFeSkWMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/GuestOrderDetails.vue?macro=true";
import { default as GuestReturnDetailsRz190kBtgbMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/GuestReturnDetails.vue?macro=true";
import { default as BillingDetailso9P1jbkgVbMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/BillingDetails.vue?macro=true";
import { default as CreateReturnsHDZXtjnyIQMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/CreateReturns.vue?macro=true";
import { default as DeleteProfilerQngrI8DRMMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/DeleteProfile.vue?macro=true";
import { default as MyProfilexbcjitN1kuMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/MyProfile.vue?macro=true";
import { default as OrderDetailsdLNAkT5y1yMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/OrderDetails.vue?macro=true";
import { default as OrderHistoryINau4mqK8uMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/OrderHistory.vue?macro=true";
import { default as ReturnDetails3rZnEohT9AMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/ReturnDetails.vue?macro=true";
import { default as ReturnsOverviewRXxxw7tJvjMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/ReturnsOverview.vue?macro=true";
import { default as ShippingDetailsI46qYuX2efMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/ShippingDetails.vue?macro=true";
import { default as PreferredFilialCh6EStpM9PMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/PreferredFilial.vue?macro=true";
import { default as RegisteryRxFatTRmzMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Register.vue?macro=true";
import { default as ResetPasswordxwt9mK2Cw2Meta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/ResetPassword.vue?macro=true";
import { default as WishlistkJ46zuaH8nMeta } from "/builds/shop22/kik-storefront-monorepo/storefront/pages/Wishlist.vue?macro=true";
export default [
  {
    name: "product",
    path: "/p/:slug/:id",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Product.vue")
  },
  {
    name: "category-new",
    path: "/c/n/:type/:slug_1?/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    meta: {"isNew":true},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Category.vue")
  },
  {
    name: "category-sale",
    path: "/c/s/:type/:slug_1?/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    meta: {"isSale":true},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Category.vue")
  },
  {
    name: "category",
    path: "/c/:slug_1/:slug_2?/:slug_3?/:slug_4?/:slug_5?",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Category.vue")
  },
  {
    name: "search",
    path: "/search/:slug_2?",
    meta: {"isSearch":true},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Category.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: {"layout":"checkout","middleware":["cart-not-empty"]},
    redirect: "/checkout/cart",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout.vue"),
    children: [
  {
    name: "shipping",
    path: "shipping",
    meta: {"layout":"checkout"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Shipping.vue")
  },
  {
    name: "shipping-customer",
    path: "shipping-customer",
    meta: {"layout":"checkout","type":"customer"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Shipping.vue")
  },
  {
    name: "shipping-guest",
    path: "shipping-guest",
    meta: {"layout":"checkout","type":"guest"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Shipping.vue")
  },
  {
    name: "shipping-new-customer",
    path: "shipping-new-customer",
    meta: {"layout":"checkout","type":"new-customer"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Shipping.vue")
  },
  {
    name: "switchView",
    path: "switchView",
    meta: {"layout":"checkout","middleware":["switch-view-redirect"]},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/SwitchView.vue")
  },
  {
    name: "billing",
    path: "billing",
    meta: {"layout":"checkout","type":"guest"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Billing.vue")
  },
  {
    name: "billing-customer",
    path: "billing-customer",
    meta: {"layout":"checkout","type":"customer"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Billing.vue")
  },
  {
    name: "billing-guest",
    path: "billing-guest",
    meta: {"layout":"checkout","type":"guest"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Billing.vue")
  },
  {
    name: "billing-new-customer",
    path: "billing-new-customer",
    meta: {"layout":"checkout","type":"new-customer"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Billing.vue")
  },
  {
    name: "payment-customer",
    path: "payment-customer",
    meta: {"layout":"checkout","type":"customer"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Payment.vue")
  },
  {
    name: "payment-new-customer",
    path: "payment-new-customer",
    meta: {"layout":"checkout","type":"new-customer"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Payment.vue")
  },
  {
    name: "payment-guest",
    path: "payment-guest",
    meta: {"layout":"checkout","type":"guest"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Payment.vue")
  },
  {
    name: "payment",
    path: "payment",
    meta: {"layout":"checkout"},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Payment.vue")
  },
  {
    name: "thank-you",
    path: "thank-you",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/ThankYou.vue")
  }
]
  },
  {
    name: "my-account",
    path: "/my-account/:pageName?",
    meta: {"middleware":["is-authenticated"]},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount.vue")
  },
  {
    path: "/signin",
    name: "signin",
    meta: {"middleware":["mykik-app-signin"]}
  },
  {
    name: "home",
    path: "/:catchall(.*)",
    meta: _91id_93KkZXB3l9zlMeta || {},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/[id].vue")
  },
  {
    name: "Cart",
    path: "/Cart",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Cart.vue")
  },
  {
    name: "Category",
    path: "/Category",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Category.vue")
  },
  {
    name: "Checkout",
    path: "/Checkout",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout.vue"),
    children: [
  {
    name: "Checkout-Billing",
    path: "Billing",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Billing.vue")
  },
  {
    name: "Checkout-Payment",
    path: "Payment",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Payment.vue")
  },
  {
    name: "Checkout-Shipping",
    path: "Shipping",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/Shipping.vue")
  },
  {
    name: "Checkout-SwitchView",
    path: "SwitchView",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/SwitchView.vue")
  },
  {
    name: "Checkout-ThankYou",
    path: "ThankYou",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Checkout/ThankYou.vue")
  }
]
  },
  {
    name: "filialfinder",
    path: "/filialfinder",
    meta: FilialfinderWQu5JrchmOMeta || {},
    alias: ["/znajdz-sklep","/filiaalzoeker","/vyhledat-prodejnu"],
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Filialfinder.vue")
  },
  {
    name: "GuestCreateReturn",
    path: "/GuestCreateReturn",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/GuestCreateReturn.vue")
  },
  {
    name: "GuestOrderDetails",
    path: "/GuestOrderDetails",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/GuestOrderDetails.vue")
  },
  {
    name: "GuestReturnDetails",
    path: "/GuestReturnDetails",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/GuestReturnDetails.vue")
  },
  {
    name: "MyAccount",
    path: "/MyAccount",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount.vue"),
    children: [
  {
    name: "MyAccount-BillingDetails",
    path: "BillingDetails",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/BillingDetails.vue")
  },
  {
    name: "MyAccount-CreateReturns",
    path: "CreateReturns",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/CreateReturns.vue")
  },
  {
    name: "MyAccount-DeleteProfile",
    path: "DeleteProfile",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/DeleteProfile.vue")
  },
  {
    name: "MyAccount-MyProfile",
    path: "MyProfile",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/MyProfile.vue")
  },
  {
    name: "MyAccount-OrderDetails",
    path: "OrderDetails",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/OrderDetails.vue")
  },
  {
    name: "MyAccount-OrderHistory",
    path: "OrderHistory",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/OrderHistory.vue")
  },
  {
    name: "MyAccount-ReturnDetails",
    path: "ReturnDetails",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/ReturnDetails.vue")
  },
  {
    name: "MyAccount-ReturnsOverview",
    path: "ReturnsOverview",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/ReturnsOverview.vue")
  },
  {
    name: "MyAccount-ShippingDetails",
    path: "ShippingDetails",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/MyAccount/ShippingDetails.vue")
  }
]
  },
  {
    name: "preferredfilial",
    path: "/preferredfilial",
    meta: PreferredFilialCh6EStpM9PMeta || {},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/PreferredFilial.vue")
  },
  {
    name: "Product",
    path: "/Product",
    meta: ProductU91JuycuoUMeta || {},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Product.vue")
  },
  {
    name: "Register",
    path: "/Register",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Register.vue")
  },
  {
    name: "ResetPassword",
    path: "/ResetPassword",
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/ResetPassword.vue")
  },
  {
    name: "Wishlist",
    path: "/Wishlist",
    meta: WishlistkJ46zuaH8nMeta || {},
    component: () => import("/builds/shop22/kik-storefront-monorepo/storefront/pages/Wishlist.vue")
  }
]